/**
 * La terminación de una cuenta, «···4521», como la escribe cualquier banco.
 *
 * ⚠ **Los puntos son para el ojo; el lector de pantalla oye «terminada en 4521».**
 * Leídos tal cual serían «punto, punto, punto, cuatro mil quinientos veintiuno».
 *
 * Sin terminación no pinta nada: tres puntos solos prometen un número que no hay.
 */
export function Terminacion({ ultimos4 }: { ultimos4: string | null }) {
  if (ultimos4 === null) return null
  return (
    <span className="tabular">
      <span aria-hidden={true}>···</span>
      <span className="sr-only">terminada en </span>
      {ultimos4}
    </span>
  )
}
